/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confidential_DocumentInputs */

const en_confidential_document = /** @type {(inputs: Confidential_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confidential`)
};

const id_confidential_document = /** @type {(inputs: Confidential_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rahasia`)
};

/** @type {(inputs: Confidential_DocumentInputs) => LocalizedString} */
const es_confidential_document = en_confidential_document;

/** @type {(inputs: Confidential_DocumentInputs) => LocalizedString} */
const fr_confidential_document = en_confidential_document;

/** @type {(inputs: Confidential_DocumentInputs) => LocalizedString} */
const de_confidential_document = en_confidential_document;

/** @type {(inputs: Confidential_DocumentInputs) => LocalizedString} */
const ja_confidential_document = en_confidential_document;

/** @type {(inputs: Confidential_DocumentInputs) => LocalizedString} */
const zh_confidential_document = en_confidential_document;

/** @type {(inputs: Confidential_DocumentInputs) => LocalizedString} */
const ar_confidential_document = en_confidential_document;

/** @type {(inputs: Confidential_DocumentInputs) => LocalizedString} */
const it_confidential_document = en_confidential_document;

/** @type {(inputs: Confidential_DocumentInputs) => LocalizedString} */
const ru_confidential_document = en_confidential_document;

/** @type {(inputs: Confidential_DocumentInputs) => LocalizedString} */
const pt_confidential_document = en_confidential_document;

/** @type {(inputs: Confidential_DocumentInputs) => LocalizedString} */
const ko_confidential_document = en_confidential_document;

/**
* | output |
* | --- |
* | "Confidential" |
*
* @param {Confidential_DocumentInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const confidential_document = /** @type {((inputs?: Confidential_DocumentInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confidential_DocumentInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_confidential_document(inputs)
	if (locale === "es") return es_confidential_document(inputs)
	if (locale === "fr") return fr_confidential_document(inputs)
	if (locale === "de") return de_confidential_document(inputs)
	if (locale === "ja") return ja_confidential_document(inputs)
	if (locale === "zh") return zh_confidential_document(inputs)
	if (locale === "ar") return ar_confidential_document(inputs)
	if (locale === "id") return id_confidential_document(inputs)
	if (locale === "it") return it_confidential_document(inputs)
	if (locale === "ru") return ru_confidential_document(inputs)
	if (locale === "pt") return pt_confidential_document(inputs)
	return ko_confidential_document(inputs)
});